import React, { createContext } from 'react'
import { useKeycloak } from '@react-keycloak/web'
import { FormattedMessage } from 'react-intl'
import UserServices from './Services/Consumers/UserServices'

const NonCoreLinkRequestsContext = createContext({})

const NonCoreLinkRequestsProvider = ({ children }) => {
  const { keycloak } = useKeycloak()
  const headerColumns = [
    {
      id: 'request_number',
      label: <FormattedMessage id='nonCoreLink.requestNumber'/>,
      minWidth: 100
    },
    {
      id: 'tax_id',
      label: <FormattedMessage id='incentivesForm.placeholder.companyTaxId'/>,
      minWidth: 130
    },
    {
      id: 'email',
      label: <FormattedMessage id='linkCompanyForm.placeholder.email'/>,
      minWidth: 100
    },
    {
      id: 'phone',
      label: <FormattedMessage id='linkCompanyForm.placeholder.mobile'/>,
      minWidth: 160
    },
    {
      id: 'tax_office_number',
      label: <FormattedMessage id='nonCoreLink.tax_office_number'/>,
      minWidth: 100
    },
    {
      id: 'expiration_date',
      label: <FormattedMessage id='nonCoreLink.expiry_date'/>,
      minWidth: 146
    },

    {
      id: 'status',
      label: <FormattedMessage id='nonCoreLink.status'/>,
      minWidth: 120
    },
    {
      id: 'rejection_reason',
      label: <FormattedMessage id='nonCoreLink.rejection_reason'/>,
      minWidth: 180
    },
    // {
    //   id: 'action_by',
    //   label: <FormattedMessage id='nonCoreLink.action_by'/>,
    //   minWidth: 150
    // },
    {
      id: 'action_at',
      label: <FormattedMessage id='nonCoreLink.action_at'/>,
      minWidth: 146
    }
  ]

  const [nonCoreLinkRequests, setNonCoreLinkRequests] = React.useState([])
  const [nonCoreLinkRequestsLoading, setNonCoreLinkRequestsLoading] = React.useState(false)
  const [nonCoreLinkRequestsFailure, setNonCoreLinkRequestsFailure] = React.useState(false)
  const [nonCoreLinkRequestsFailure403, setNonCoreLinkRequestsFailure403] = React.useState(false)
  const getRequests = () => {
    if (!!keycloak?.authenticated) {
      setNonCoreLinkRequestsLoading(true)
      setNonCoreLinkRequestsFailure(false)
      setNonCoreLinkRequestsFailure403(false)
      UserServices.nonCoreRequests({
        headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` },
        params: { 'page': 0, 'limit': 0 }
      }).then((result) => {
        if ((!!result.response && result.response.status !== 200) || !result) {
          setNonCoreLinkRequestsFailure(true)
          if (!!result.response && result.response.status === 403) {
            setNonCoreLinkRequestsFailure403(true)
          }
          setNonCoreLinkRequestsLoading(false)
        } else {
          if (!!result && !!result.data) {
            setNonCoreLinkRequests(result.data)
          }
        }
      }).then(() => {
        setNonCoreLinkRequestsLoading(false)
      })
    }
  }


  React.useEffect(() => {
      getRequests()
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])


  return (
    <NonCoreLinkRequestsContext.Provider value={{
      headerColumns,
      nonCoreLinkRequests,
      nonCoreLinkRequestsLoading,
      nonCoreLinkRequestsFailure,
      nonCoreLinkRequestsFailure403

    }}>
      {children}
    </NonCoreLinkRequestsContext.Provider>
  )
}
const NonCoreLinkRequestsConsumer = NonCoreLinkRequestsContext.Consumer

export { NonCoreLinkRequestsProvider, NonCoreLinkRequestsConsumer, NonCoreLinkRequestsContext }
